import { JsonPipe } from "@angular/common";
import { Component } from "@angular/core";
import { TranslatePipe, provideTranslationScope } from "@app/shared/i18n/translation-scope";
import { scope } from "@app/manual/i18n/scope";
import { ApiSpecificationModel } from "@app/manual/models/api-models/api-specification-model";
import { ApiSpecComponent } from "../../api-spec";

@Component({
    selector: "app-control-generate-samples-api-manual",
    templateUrl: "../../api-spec.html",
    styleUrls: ["../../api-spec.scss"],
    standalone: true,
    imports: [JsonPipe, TranslatePipe],
    viewProviders: [provideTranslationScope(scope)]
})
export class ControlGenerateSamplesApiManualComponent extends ApiSpecComponent {
    initSpecs() {
        return <ApiSpecificationModel>{
            name: this.translation.t("specs.controlGenerateSamplesApi"),
            httpMethod: "POST",
            path: "/controls/testing/advanced/effectiveness/{effectivenessGuid}/automation/samples/generate",

            parameters: [
                {
                    name: "effectivenessGuid",
                    in: "path",
                    paramType: "uuid",
                    required: true,
                    example: "00000000-0000-0000-0000-000000000000",
                },
                {
                    name: "sampleMethod",
                    description: this.translation.t("parameters.controlSampleMethodDescription"),
                    in: "query",
                    paramType: "string",
                    required: true,
                    enum: ["number", "date", "spreadsheet"],
                },
                {
                    name: "population",
                    description: this.translation.t("parameters.controlPopulationDescription"),
                    in: "query",
                    paramType: "integer",
                    required: true,
                    example: "1 | 2 | 3",
                },
                {
                    name: "numberOfSamples",
                    in: "query",
                    paramType: "integer",
                    required: true,
                    example: "1 | 2 | 3",
                },
            ],

            responses: [
                {
                    code: "200",
                    description: "OK",
                    example: "Request has been successfully processed",
                },
            ],
        };
    }
}
